import { atom } from 'recoil';
import { IChart } from './types';

export const IsChartsState = atom<boolean>({
  key: 'is-charts',
  default: false,
});

export const ChartsState = atom<IChart[]>({
  key: 'charts-data',
  default: [],
});

export const SelectedChartState = atom<IChart>({
  key: 'selected-chart',
  default: {},
});

export const IsTitleRenameState = atom<boolean>({
  key: 'title-rename-modal',
  default: false,
});

export const IsDetailRenameState = atom<boolean>({
  key: 'detail-title-rename-modal',
  default: false,
});

export const isEditModalState = atom<boolean>({
  key: 'is-edit-modal',
  default: false,
});

export const ChartSearchState = atom<string>({
  key: 'chart-search-chart',
  default: '',
});

export const IsChartDeleteState = atom<boolean>({
  key: 'is-chart-delete',
  default: false,
});

export const IsDeleteBtnLoaderState = atom<boolean>({
  key: 'is-delete-btn-loader',
  default: false,
});

export const IsChartDetailDeleteState = atom<boolean>({
  key: 'is-chart-detail-delete',
  default: false,
});

export const selectedChartMenuState = atom<IChart>({
  key: 'selected-chart-menu',
  default: {},
});
